import React from 'react';
import { Redirect, Route } from 'react-router-dom';

export const PrivateRoute = ({ component: Component, ...rest }) => {
  const hasUser = !!localStorage.getItem('User');

  return (
    <Route
      {...rest}
      render={props => {
        if (hasUser) {
          return <Component {...props} />;
        } else {
          return <Redirect to="/login" />;
        }
      }}
    />
  );
};

export const PublicRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props =>   <Component {...props} />} />
);
